import { useReducer } from 'react'
import { getUserMessagesThreads } from '../../../services/userService'
import { deepCopy } from '../../../util/Utils'
import { UTCDateStringToTimestamp } from '../../../util/DateUtil'

export default () => {}

export function useUserMessagesController(cisId) {
  const initialState = {
    cisId,
    messages: [],
    participants: {},
    pagination: {
      currentPage: 0,
      itemsPerPage: 500,
      totalItems: 500,
    },
    filters: {
      participant: null,
      startDate: null,
      endDate: null,
    },
    sort: {
      sortBy: 'lastModifiedTime',
      ascending: false,
    },
  }

  function reducer(oldState, action) {
    const newState = deepCopy(oldState)
    action.updateState(newState, action.params)
    return newState
  }

  const [messagesState, messagesDispatch] = useReducer(reducer, initialState)

  const messagesActions = {
    setAscending: (ascending) => {
      messagesDispatch({
        updateState: messagesSort,
        params: {
          sortBy: messagesState.sort.sortBy,
          ascending,
        },
      })
    },
    setParticipant: (participant) => {
      messagesDispatch({
        updateState: setParticipant,
        params: {
          participant,
        },
      })
    },
    setStartDate: (startDate) => {
      messagesDispatch({
        updateState: setStartDate,
        params: {
          startDate,
        },
      })
    },
    setEndDate: (endDate) => {
      messagesDispatch({
        updateState: setEndDate,
        params: {
          endDate,
        },
      })
    },
    nextPaginatorPage: (currentPage) => {
      messagesActions.fetchMessages(currentPage)
    },
    setCurrentPage: (currentPage) => {
      messagesDispatch({
        updateState: setCurrentPage,
        params: {
          currentPage,
        },
      })
    },
    setItemsPerPage: (itemsPerPage) => {
      messagesDispatch({
        updateState: setItemsPerPage,
        params: {
          itemsPerPage,
        },
      })
    },
    setTotalItems: (totalItems) => {
      messagesDispatch({
        updateState: setTotalItems,
        params: {
          totalItems,
        },
      })
    },
    fetchMessages: async (currentPage) => {
      return getUserMessagesThreads(
        messagesState.cisId,
        messagesState.filters?.participant?.cisId,
        messagesState.filters?.startDate?.primaryText,
        messagesState.filters?.endDate?.primaryText,
        currentPage,
        messagesState.pagination?.itemsPerPage
      ).then((data) => {
        messagesActions.setMessages(data.messages)
        messagesActions.appendParticipants(data.participants)
        messagesActions.setTotalItems(data.totalPages * messagesState.pagination.itemsPerPage)
        messagesActions.setCurrentPage(currentPage)
        return Promise.resolve()
      })
    },
    setMessages: (messages) => {
      messagesDispatch({
        updateState: setMessages,
        params: {
          messages,
        },
      })
    },
    appendParticipants: (participants) => {
      messagesDispatch({
        updateState: appendParticipants,
        params: {
          participants,
        },
      })
    },
  }

  return { messagesState, messagesActions }
}

export function setCurrentPage(newState, params) {
  newState.pagination.currentPage = params.currentPage
}

export function setItemsPerPage(newState, params) {
  newState.pagination.itemsPerPage = params.itemsPerPage
}

export function setTotalItems(newState, params) {
  newState.pagination.totalItems = params.totalItems
}

export function setParticipant(newState, params) {
  newState.filters.participant = params.participant
}

export function setStartDate(newState, params) {
  newState.filters.startDate = params.startDate
}

export function setEndDate(newState, params) {
  newState.filters.endDate = params.endDate
}

export function setMessages(newState, params) {
  newState.messages = params.messages
  newState.sort.ascending = false
  newState.messages.sort((a, b) =>
    sortNumbers(UTCDateStringToTimestamp(b.lastModifiedTime), UTCDateStringToTimestamp(a.lastModifiedTime))
  )
}

export function appendParticipants(newState, params) {
  Object.keys(params.participants).forEach((participantId) => {
    newState.participants[participantId] = params.participants[participantId]
  })
}

export function messagesSort(newState, params) {
  newState.sort.ascending = params.ascending
  newState.sort.sortBy = params.sortBy

  if (newState.sort.sortBy === 'lastModifiedTime') {
    if (newState.sort.ascending) {
      newState.messages.sort((a, b) =>
        sortNumbers(UTCDateStringToTimestamp(a.lastModifiedTime), UTCDateStringToTimestamp(b.lastModifiedTime))
      )
    } else {
      newState.messages.sort((a, b) =>
        sortNumbers(UTCDateStringToTimestamp(b.lastModifiedTime), UTCDateStringToTimestamp(a.lastModifiedTime))
      )
    }
  }
}

function sortNumbers(a, b) {
  if (a === b) {
    return 0
  }
  if (a < b) {
    return -1
  }
  return 1
}
